import styles from './badge.module.scss';

export type BadgeTone = 'green' | 'blue' | 'teal' | 'amber' | 'red' | 'grey' | 'outline';

export const Badge = ({ label, tone }: { label: string; tone: BadgeTone }) => (
  <span className={styles.badge} data-tone={tone}>
    {label}
  </span>
);
